import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ContainerScrollModule } from '@app/components/container-scroll/container-scroll.module';
import { SharedModule } from '@app/shared/shared.module';
import { SubscriptionIntroComponent } from './subscription-intro/subscription-intro.component';

import { SubscriptionRoutingModule } from './subscription-routing.module';
import { SubscriptionComponent } from './subscription/subscription.component';
import { SubscriptionsPlansComponent } from './subscriptions-plans/subscriptions-plans.component';
import {HeaderModule} from "@app/components/header/header.module";


@NgModule({
  declarations: [
    SubscriptionIntroComponent,
    SubscriptionComponent,
    SubscriptionsPlansComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    SubscriptionRoutingModule,
    ContainerScrollModule,
    HeaderModule
  ]
})
export class SubscriptionModule { }
